import type { LocationQuery } from 'vue-router';
import { getSearchQueryFromRoute } from './query-formatters';

/**
 * The source of a search, read from the route: the `source` param whatever navigated here wrote (a filter
 * change, the search box, a link from another page), else 'link' when the URL carries a search, else 'empty_page'.
 */
export const getSearchSource = (query: LocationQuery): string => {
  if (typeof query.source === 'string') {
    return query.source;
  }

  const { q, filter, sort } = getSearchQueryFromRoute(query);
  return q || Object.keys(filter ?? {}).length > 0 || sort?.length ? 'link' : 'empty_page';
};
